import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { Fragment, useContext, useMemo } from "react"
import { AppContext } from "Views/Home/context"
import { CalendarContext } from "./context"
import BoardItem from "./BoardItem"
import EmptyItem from "./EmptyItem"
import SelectedDate from "./SelectTool/SelectedDate"
import SelectWrap from "./SelectTool/SelectWrap"
import SelectItem from "./SelectTool/SelectItem"
import MoveWrap from "./MoveTool/MoveWrap"
import CandidateList from "./MoveTool/CandidateList"
import MoveItem from "./MoveTool/MoveItem"
import cal from "clsx"
import { AdPlace } from "Types/place"
import { Board } from "Types/board"
import { useSwitch } from "Hooks/basic"
import { generateDateRange } from "Methods/date"

const useStyles = makeStyles(() => ({
    root: {
        borderTop: "2px solid #ddd",
        width: "100%",
        position: "relative",
        height: "63vh",
        overflowY: "scroll",
    },
    rootSpecies: {
        borderTop: "2px solid #ddd",
        width: "100%",
        position: "relative",
        height: "43vh",
        overflowY: "scroll",
    },
    item: {
        display: "flex",
        width: "100%",
    },
    weChatItem: {
        "&:nth-child(5n + 1)": {
            marginTop: 20,
            borderTop: "2px solid #ddd",
        },
    },
    label: {
        width: "130px",
        borderBottom: "1px solid #ddd",
        padding: "2px 4px",
        userSelect: "none",
    },
    moveMask: {
        width: "99%",
        height: "99%",
        backgroundColor: "rgba(0,0,0,.2)",
        borderRadius: 6,
        zIndex: 1,
    },
}))

const CalendarContent = () => {
    const classes = useStyles()
    const {
        places, currentDate, board, channelName,
        isWeChat, isWeibo, isSpecies, isHealth
    } = useContext(CalendarContext)
    const { user } = useContext(AppContext)
    const { role } = user || {}
    const { role_name } = role || {}
    const isTrueEditor = role_name === "true_editor"
    const isSideEditor = role_name === "side_editor"
    const isOpEditor = role_name === "op_editor"
    const { dateRange, boardMap } = useMemo(() => {
        const dateRange = generateDateRange(currentDate)
        const Monday = dateRange[0]
        const Sunday = dateRange[dateRange.length - 1]
        const boardMap: { [keys: number]: Board } = {}
        for (const boardItem of board) {
            const adTime: number = new Date(boardItem.ad_time).setHours(0, 0, 0, 0)
            const ChannelName: string = boardItem.channel ? boardItem.channel.name : ""
            const PlaceId: number = boardItem.ad_place_id
            const SeqId: number = boardItem.seq_id
            if (adTime >= Monday.getTime() && adTime <= Sunday.getTime() && ChannelName === channelName) {
                if (['童学馆', '美丽', '果壳视频', '摄影', '果壳自然', '吃货', '果壳病人'].includes(channelName)) {
                    boardMap[(adTime + SeqId)] = boardItem
                } else if (isWeChat) {
                    boardMap[(adTime + SeqId)] = boardItem
                } else {
                    boardMap[(adTime + PlaceId)] = boardItem
                }
            }
        }
        return { dateRange, boardMap }
    }, [currentDate, board, channelName, isWeChat])
    const { open, toggle } = useSwitch(false)
    return (
        <div className={['果壳自然', '果壳病人'].includes(channelName) ? classes.rootSpecies : classes.root}>
            <MoveWrap>
                <div style={{ flexGrow: 1 }}>
                    {
                        places.map((place: AdPlace) => (
                            <div className={cal(
                                classes.item,
                                (isWeChat || isWeibo || ['果壳自然', '果壳病人'].includes(channelName)) && classes.weChatItem,
                            )} key={place.id}>
                                <div className={classes.label}>{place.name}</div>
                                <SelectWrap place={place} toggle={toggle}>
                                    <SelectedDate placeId={place.id} />
                                    {
                                        dateRange.map((d: Date) => (
                                            <SelectItem
                                                addLocked={open}
                                                toggle={toggle}
                                                boardMap={boardMap}
                                                place={place}
                                                d={d}
                                                key={d.getTime()}
                                            >
                                                {
                                                    boardMap[place.id + d.getTime()]
                                                        ? (
                                                            <Fragment>
                                                                <BoardItem
                                                                    board={boardMap[place.id + d.getTime()]}
                                                                    date={d}
                                                                />
                                                            </Fragment>
                                                        )
                                                        : (<EmptyItem place={place} date={d} />)
                                                }
                                            </SelectItem>
                                        ))
                                    }
                                </SelectWrap>
                            </div>
                        ))
                    }
                </div>
                {
                    (((isTrueEditor || isSideEditor || isOpEditor)
                    && (isWeChat || isWeibo || isSpecies || isHealth)) || (channelName === '吃货' && user)) &&
                    (<CandidateList />)
                }
                <MoveItem />
            </MoveWrap>
        </div>
    )
}

export default CalendarContent
